import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import environment from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PostcodeService {
  constructor(private readonly http: HttpClient) {}

  public validatePostcode(postcode: string): Observable<any> {
    const endpoint = `${environment.postcodeUrl}${postcode}`;
    return this.http.get(endpoint);
  }
}
